import { compose } from 'lodash/fp'
import React, { useRef } from 'react'
import Flex from 'typescript-styled-flex'
import { Input } from '../elements'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import MaxLength from '../TextareaInput/MaxLength'
import SpinningIcon from './SpinningIcon'
import withRedux from './withRedux'

const TextInput = FormElement(
  ({
    name,
    placeholder,
    isSelected,
    errorMsg,
    warningMsg,
    onChange,
    onClick,
    onFocus,
    onBlur,
    onBlurCustom,
    required,
    value,
    disabled,
    withAfterIcon,
    withBeforeIcon,
    size = 1,
    alignCenter = false,
    className,
    isValidating,
    anchorRef,
    inputStyle,
    wrapperClick,
    afterIconStyle,
    autocomplete,
    maxLength,
    disableCounter = false,
    type = 'text',
    isSmallReservation,
    onMouseDown,
    readonly,
    onKeyDown,
    dirty,
    errorOnMax,
  }: IFormElementProps) => {
    const ref = useRef<HTMLInputElement>()

    const focus = () => {
      ref.current.focus()
      ref.current.click()
    }

    return (
      <Flex
        justifyEnd={true}
        alignStart={!alignCenter}
        alignCenter={alignCenter}
        style={{ position: 'relative' }}
        column={maxLength > 0}
        alignEnd={maxLength > 0}
        ref={anchorRef}
      >
        <Input
          id={'text-input'}
          ref={ref}
          name={name}
          autoComplete={autocomplete}
          style={inputStyle}
          placeholder={dirty ? undefined : placeholder}
          onClick={onClick}
          selected={isSelected}
          onKeyDown={onKeyDown}
          error={
            (errorMsg && errorMsg !== '') ||
            (errorOnMax && value.length === maxLength)
          }
          warning={warningMsg && warningMsg !== ''}
          type={type}
          onChange={onChange}
          onBlur={onBlur || onBlurCustom}
          onFocus={onFocus}
          maxLength={maxLength}
          required={required}
          value={value}
          disabled={disabled}
          className={className}
          smallReservation={isSmallReservation}
          size={size}
          readOnly={readonly}
          onMouseDown={onMouseDown}
          data-cy={className}
        />
        {maxLength > 0 && !disableCounter && (
          <Flex alignCenter={true} justifyEnd={true}>
            <MaxLength max={value.length === maxLength}>
              {value.length} / {maxLength}
            </MaxLength>
          </Flex>
        )}
        {!isValidating && withAfterIcon && (
          <Flex
            onClick={focus}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: '10px',
              ...afterIconStyle,
            }}
          >
            {withAfterIcon}
          </Flex>
        )}
        {withBeforeIcon && (
          <Flex
            onClick={focus}
            style={{ cursor: 'pointer', left: '10px', position: 'absolute' }}
          >
            {withBeforeIcon}
          </Flex>
        )}
        {isValidating && (
          <Flex style={{ position: 'absolute', right: '10px' }}>
            <SpinningIcon />
          </Flex>
        )}
      </Flex>
    )
  },
)

const ReduxField: React.ComponentType<IFormElementProps> = compose(
  withReduxForm,
  withRedux,
)(TextInput)

export default ReduxField
export { TextInput }
